export const STEP = {
  SELECT_CHARACTER_TYPE: "select_character_type",
  SELECT_HUMAN: "select_human",
  ADD_CHARACTER: "add_character",
  CHARACTER_FROM_HUMAN: "character_from_human",
  CHARACTER_FROM_OTHERS: "character_from_others",
};
